export function getPasswordErrors(password) {
  const errors = [];

  if ([...password].length < 12) errors.push('La contraseña debe contener al menos 12 caracteres');
  if (!/\p{Lu}/u.test(password)) errors.push('La contraseña debe contener al menos una mayúscula');
  if (!/\p{N}/u.test(password)) errors.push('La contraseña debe contener al menos un número');
  if (!/[^\p{L}\p{N}]/u.test(password)) errors.push('La contraseña debe contener al menos un símbolo');

  return errors;
}
